export default "__VITE_ASSET__BzMPATYB__"